import { render } from "./UiToastList.vue?vue&type=template&id=2c98275e&scoped=true"
import script from "./UiToastList.vue?vue&type=script&lang=js"
export * from "./UiToastList.vue?vue&type=script&lang=js"

import "./UiToastList.vue?vue&type=style&index=0&id=2c98275e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c98275e"]])

export default __exports__